import { render } from "./EditGroupPermissionPage.vue?vue&type=template&id=ad1f4780&ts=true"
import script from "./EditGroupPermissionPage.vue?vue&type=script&lang=ts"
export * from "./EditGroupPermissionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__